export default __webpack_public_path__ + "locales/sl/InviteDialog.json?hash=b0eef4513b79a8de98445a0ba21cc075";